import React from "react";
import { Box } from "@mui/material";

export interface FilterBarProps {
  children: React.ReactNode;
}

/** Horizontal bar of filters and actions at the top of a table card. */
export function FilterBar({ children }: FilterBarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
        px: 4,
        py: 3,
      }}
    >
      {children}
    </Box>
  );
}

export default FilterBar;
